/**
 * Page to top functionality
 */
const pageTop = () => {
  const page = document.querySelector('.js-pagetop');

  page?.addEventListener('click', () => {
    document.body.scrollIntoView({ behavior : 'smooth' });
  });
};

export default pageTop;